import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe({
  name: 'sanitize',
  standalone: true,
})
export class SanitizePipe implements PipeTransform {
  private domSanitizer = inject(DomSanitizer);


  transform(value: string): SafeHtml {
    return this.domSanitizer.sanitize(SecurityContext.HTML, value) || value;
  }
}
